<button *ngIf="enableExport"
        data-test="export-button"
        class="btn btn-border-radius btn-secondary"
        [ngClass]="getCls()"
        [disabled]="monDisabled || exports.length === 0"
        (click)="exportFiles()"
        monEventTrigger="actionTrigger"
        [monEventParams]="{action: 'btn-export-dialog'}"
        [ngbTooltip]="'Export' | translate"
        [triggers]="'focus hover'"
        [attr.aria-label]="'Export' | translate">
  <span class="fas fa-download" aria-hidden="true"></span>
  <span class="sr-only">{{ 'Export' | translate }}</span>
</button>
